module.exports = __webpack_public_path__ + "static/media/aicte-logo.c954de05.png";